module.exports = __webpack_public_path__ + "img/newPaintingPav5m.ab8838fb.png";